export const CHECKOUT_URL = 'https://contabilidad-practica.impultienda.ar/checkout'

/* Todos los botones e imágenes llevan a la sección de compra */
export const OFFER_ANCHOR = '#oferta'

export const SUPPORT_EMAIL = 'soportescmdigital@gmail.com'

export const PACK_IMAGE =
  'https://cdn.magicpatterns.com/uploads/4ENttbsSwKYcNnjueoxKk9/Mega_Pack_Contabilidad_Practica_Argentina_2026.png'

export const PRODUCT_NAME = 'MEGA PACK CONTABILIDAD PRÁCTICA ARGENTINA 2026'

export const PRICE = '$19.990'

export const BONUS_TOTAL = '$39.950'

/* 1. PROBLEMA */
export const problems = [
  {
    title: 'INFORMACIÓN DISPERSA',
    desc: 'Guardás videos sobre asientos contables, balances, Monotributo, IVA, sueldos y Ganancias, pero cada explicación parece diferente y no sabés cómo relacionar todos los temas.',
  },
  {
    title: 'NO SABÉS QUÉ APRENDER PRIMERO',
    desc: 'Debe, Haber, Libro Diario, balances, facturación, declaraciones juradas, cargas sociales... hay tantos conceptos y obligaciones que comenzar parece complicado.',
  },
  {
    title: 'TE FALTA UNA RUTA',
    desc: 'Querés aprender una habilidad práctica que te ayude a administrar mejor un negocio o ampliar tus conocimientos laborales, pero necesitás avanzar desde los fundamentos hasta los ejercicios reales.',
  },
  {
    title: 'SEGUÍS POSTERGANDO',
    desc: 'Querés comenzar, pero pasan las semanas y seguís buscando explicaciones, descargando archivos y mirando tutoriales sin tener un método de estudio organizado.',
  },
]

/* 2. SOLUCIÓN — 6 TOMOS */
export const tomos = [
  {
    title: 'CONTABILIDAD DESDE CERO – ASIENTOS, LIBROS Y BALANCES',
    desc: 'Comprendé los fundamentos contables, Activo, Pasivo, Patrimonio Neto, Debe y Haber, partida doble, Libro Diario, Libro Mayor, registraciones, ajustes y balances con ejemplos prácticos.',
  },
  {
    title: 'MONOTRIBUTO Y FACTURACIÓN ARGENTINA',
    desc: 'Aprendé cómo funciona el Monotributo, las categorías, la facturación electrónica, los comprobantes, las obligaciones habituales y los controles necesarios para organizar una actividad independiente.',
  },
  {
    title: 'IVA: LIQUIDACIÓN Y DECLARACIONES JURADAS',
    desc: 'Comprendé IVA Débito Fiscal, Crédito Fiscal, compras, ventas, comprobantes, saldos, retenciones y el procedimiento general de liquidación mediante ejercicios resueltos.',
  },
  {
    title: 'LIQUIDACIÓN DE SUELDOS Y CARGAS SOCIALES',
    desc: 'Aprendé los conceptos de sueldo bruto y neto, recibos, descuentos, aportes, contribuciones, aguinaldo, vacaciones y registraciones laborales con ejemplos paso a paso.',
  },
  {
    title: 'IMPUESTO A LAS GANANCIAS Y BIENES PERSONALES',
    desc: 'Conocé los fundamentos de estos impuestos, ingresos, gastos, deducciones, bienes alcanzados, valuaciones, declaraciones juradas y ejercicios de determinación simplificada.',
  },
  {
    title: 'SOCIEDADES, GESTIÓN CONTABLE Y CASOS INTEGRADORES',
    desc: 'Comprendé la organización contable de empresas, sociedades, patrimonio, resultados, controles administrativos, indicadores financieros y casos que integran los conocimientos aprendidos.',
  },
]

/* 3. BONOS */
export const bonuses = [
  {
    title: '100 ASIENTOS CONTABLES RESUELTOS PASO A PASO',
    desc: '100 ejemplos organizados por capital, compras, ventas, gastos, IVA, sueldos, bancos, bienes de uso, ajustes y cierre contable para practicar la registración de operaciones.',
    value: '$7.990',
  },
  {
    title: '50 EJERCICIOS DE LIQUIDACIÓN DE IMPUESTOS CON SOLUCIONES',
    desc: '50 ejercicios prácticos de Monotributo, IVA, Ganancias, Bienes Personales, retenciones, percepciones y controles tributarios, con cálculos y respuestas explicadas.',
    value: '$5.990',
  },
  {
    title: 'PLANTILLAS DE EXCEL PARA CONTABILIDAD Y ADMINISTRACIÓN',
    desc: '10 modelos de planillas con estructuras, fórmulas y ejemplos para crear controles de Libro Diario, caja, bancos, ventas, compras, inventarios, sueldos, resultados y cuentas por cobrar.',
    value: '$6.990',
  },
  {
    title: '30 CASOS PRÁCTICOS DE EMPRESAS ARGENTINAS',
    desc: '30 situaciones de comercios, profesionales, empresas de servicios y sociedades, con ejercicios de costos, ganancias, impuestos, sueldos, inventarios y decisiones financieras.',
    value: '$8.990',
  },
  {
    title: 'GUÍA DE TRÁMITES Y OBLIGACIONES ANTE ARCA 2026',
    desc: 'Una guía organizada para comprender CUIT, clave fiscal, Monotributo, facturación electrónica, IVA, Ganancias, empleadores, vencimientos y documentación tributaria.',
    value: '$9.990',
  },
]

/* 4. BENEFICIOS */
export const benefits = [
  {
    title: 'MENOS CONFUSIÓN',
    desc: 'Dejá de saltar entre tutoriales y seguí una ruta organizada desde los fundamentos contables hasta los impuestos, las registraciones, los balances y los ejercicios integradores.',
  },
  {
    title: 'MÁS CONOCIMIENTO PRÁCTICO',
    desc: 'Comprendé asientos contables, Libro Diario, balances, Monotributo, IVA, sueldos, Ganancias y administración mediante explicaciones y actividades organizadas.',
  },
  {
    title: 'COMPRENDÉ LO QUE ESTÁS HACIENDO',
    desc: 'Empezá a mirar una factura, un asiento, una liquidación o un balance y reconocer qué significa cada concepto, cómo se calcula y qué información necesitás revisar.',
  },
  {
    title: 'UNA NUEVA HABILIDAD',
    desc: 'Construí conocimientos que pueden ayudarte a organizar mejor un emprendimiento, fortalecer tus estudios y prepararte para tareas administrativas acordes a tu formación.',
  },
]

/* 5. TESTIMONIOS */
export const testimonials = [
  {
    quote:
      'Estaba cursando el primer año y me trababa siempre con el Debe y el Haber. Con el Tomo 1 y los 100 asientos resueltos entendí la partida doble, cómo pasar del Libro Diario al Mayor y por qué cada registración tiene que cerrar. Ahora practico con mucha más confianza.',
    author: 'Camila Benítez',
    role: 'Estudiante de contabilidad, 22 años',
    location: 'Córdoba, Argentina',
  },
  {
    quote:
      'Tengo un local de indumentaria y la facturación era un caos. El tomo de Monotributo me ayudó a entender las categorías, los comprobantes y qué controlar cada mes. Ya no dependo de adivinar: tengo mis ventas y gastos organizados en una planilla.',
    author: 'Martín Sosa',
    role: 'Emprendedor, 34 años',
    location: 'Rosario, Argentina',
  },
  {
    quote:
      'En el trabajo cargo compras y ventas, pero no terminaba de entender cómo se armaba la posición de IVA. Con los ejercicios resueltos de Débito y Crédito Fiscal ahora reviso los comprobantes y los controles con otra mirada.',
    author: 'Lucía Fernández',
    role: 'Auxiliar administrativa, 29 años',
    location: 'Mendoza, Argentina',
  },
  {
    quote:
      'La teoría la tenía, pero me costaba aplicarla. Los 30 casos prácticos me obligaron a relacionar balances, sueldos y resultados en situaciones de empresas reales. Fue lo que más me sirvió para prepararme los parciales.',
    author: 'Tomás Aguirre',
    role: 'Estudiante de Ciencias Económicas, 20 años',
    location: 'La Plata, Argentina',
  },
  {
    quote:
      'Soy diseñadora independiente y siempre sentí que los números me superaban. Las plantillas de Excel y la guía de trámites ante ARCA me dieron una estructura clara para ordenar mis ingresos, vencimientos y documentación sin perderme.',
    author: 'Florencia Ramírez',
    role: 'Trabajadora independiente, 31 años',
    location: 'San Miguel de Tucumán, Argentina',
  },
]

/* 6. FAQ */
export const faqs = [
  { q: '¿Es físico o digital?', a: 'Es un producto 100% digital.' },
  {
    q: '¿Necesito conocimientos previos?',
    a: 'No. El sistema comienza desde los fundamentos y avanza progresivamente hacia ejercicios y casos prácticos.',
  },
  {
    q: '¿Qué voy a aprender?',
    a: 'Contabilidad básica, asientos, balances, Monotributo, facturación, IVA, sueldos, Ganancias, Bienes Personales y gestión contable.',
  },
  {
    q: '¿Incluye ejercicios?',
    a: 'Sí. Incluye ejemplos, actividades, 100 asientos resueltos, 50 ejercicios tributarios y 30 casos prácticos.',
  },
  {
    q: '¿Los bonos tienen costo adicional?',
    a: 'No. Los 5 bonos están incluidos sin costo adicional en la oferta.',
  },
  {
    q: '¿Es un pago único?',
    a: 'Sí. Realizás un único pago de $19.990, sin mensualidades.',
  },
  {
    q: '¿Obtengo acceso inmediatamente?',
    a: 'Sí. El material se entrega digitalmente después de confirmarse el pago.',
  },
  {
    q: '¿Esto me habilita profesionalmente?',
    a: 'No. Es material educativo y no otorga título, matrícula ni habilitación para ejercer tareas reservadas a contadores públicos.',
  },
  {
    q: '¿Puedo aprender a mi ritmo?',
    a: 'Sí. Podés estudiar los tomos y resolver los ejercicios según tus tiempos.',
  },
  {
    q: '¿Dónde solicito soporte?',
    a: 'Podés comunicarte por correo electrónico a soportescmdigital@gmail.com.',
  },
]

/* POP-UP DE COMPRAS RECIENTES — ARGENTINA */
export const recentBuyers = [
  { name: 'Sofía Gómez', city: 'Córdoba', minutes: 2 },
  { name: 'Lucas Romero', city: 'Rosario', minutes: 4 },
  { name: 'Valentina Díaz', city: 'Buenos Aires', minutes: 7 },
  { name: 'Julián Pereyra', city: 'Mendoza', minutes: 11 },
  { name: 'Micaela Medina', city: 'La Plata', minutes: 15 },
  { name: 'Agustín Torres', city: 'Mar del Plata', minutes: 19 },
  { name: 'Carla Acosta', city: 'Salta', minutes: 24 },
  { name: 'Ezequiel Molina', city: 'San Miguel de Tucumán', minutes: 29 },
  { name: 'Nahuel Ríos', city: 'Neuquén', minutes: 33 },
  { name: 'Carolina Herrera', city: 'Santa Fe', minutes: 40 },
]
